<template>
    <b-row>
        <b-col cols="12">
            <p>
              <strong>INSTRUCCIONES:</strong>
            </p>
            <p>{{data.instrucciones}}</p>
        </b-col>
        <b-col cols="12">
            <b-row>
                 <b-col md="3" lg="3" v-for="(elemento,index) in data.elementos" :key="elemento.id">
                    <b-card class="shadow" show-header show-footer>
                        <div v-if="elemento.tipo == 1">
                            <div style="height: 232px; width: 100%; text-align: center;">
                            <b-form-textarea
                                style="text-align: center; border: none; height: 234px;"
                                id="textarea"
                                v-model="elemento.data"
                                disabled="disabled"
                                rows="8"
                                max-rows="8"
                            ></b-form-textarea>
                            </div>
                        </div>
                        <div v-if="elemento.tipo == 2" style="text-align: center;">
                            <b-img
                                thumbnail
                                fluid
                                :src="$root.setUrlFile(elemento.data)"
                                alt="Imagen"
                                style="width: 252px; height: 232px;"
                            ></b-img>
                            <!--<div
                            :style="`height: 138px; width: 100%; background-image: url(${elemento.data}); background-repeat: no-repeat; background-size: cover; background-position: center;`"
                            ></div>-->
                        </div>
                        <div v-if="elemento.tipo == 3">
                            <div style="height: 230px; width: 100%; text-align: center;">
                            <audio
                                v-if="elemento.data != ''"
                                controls="controls"
                                autobuffer="autobuffer"
                                style="margin-top: 90px;"
                            >
                                <source :src="$root.setUrlFile(elemento.data)">
                            </audio>
                            </div>
                        </div>
                        <div slot="footer">
                            <div
                            :id="`data${index}${data.id}`"
                            draggable="true"
                            @dragstart="drag($event)"
                            @dragover.prevent
                            @drop="drop($event)"
                            :class="`elementosToMatch ${data.id}`"
                            ></div>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
                lg="3"
                md="3"
                v-for="(resp,index) in respuestasArry"
                :key="index"                                
            ><div class="listaRespuestas" :id="`resp${index}${data.id}`" draggable="true"
                @dragstart="drag($event)"
                @dragover.prevent
                @drop="drop($event)">{{resp}}</div></b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
             <b-button
                style="float: right; margin: 10px"
                variant="primary"
                @click="verificarResultados"
            >Verificar Resultados</b-button>
        </b-col>
    </b-row>
</template>

<script>
    function shuffle(array) {
        var currentIndex = array.length,
            temporaryValue,
            randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }
    export default {
        name:"pre-relacionar",
        props: {
           data: {
               type: Object,
               default: () => {
                   return {
                        index:null,
                        tag:'RelacionarContent',
                        elementos: [],
                        instrucciones: ''
                   }
               }
           }
        },
        data() {
            return {
                respuestasArry: new Array
            }
        },
        created() {
            console.log('data relacionar::',this.data);
            this.respuestasArry = [];
            this.data.elementos.forEach(el => {
                this.respuestasArry.push(el.respuesta);
            });
            this.respuestasArry = shuffle(this.respuestasArry);
        },
        methods: {
            drag(event) {
                event.dataTransfer.setData("id", event.target.id);
                event.dataTransfer.setData("value", event.target.innerHTML);
            },
            drop(ev) {
                let idOrigen = ev.dataTransfer.getData("id");
                let dataOrigen = ev.dataTransfer.getData("value");
                let elementoOrigen = document.getElementById(idOrigen);
                let idDestino = ev.target.id;
                let elementoDestino = document.getElementById(idDestino);
                let dataDestino = elementoDestino.innerHTML;
                elementoOrigen.innerHTML = dataDestino;
                elementoDestino.innerHTML = dataOrigen;
            },
             verificarResultados() {
                let matchesArry = [];
                let aciertos = 0;
                let allElements = document.getElementsByClassName(this.data.id);
                for (let i = 0; i < allElements.length; i++) {
                    matchesArry.push(allElements[i].innerHTML);
                }
                this.data.elementos.forEach((el, index) => {
                    if (el.respuesta == matchesArry[index]) {
                    allElements[index].className = "elementosToMatch "+this.data.id+" correcta";
                    aciertos++;
                    } else {
                    allElements[index].className = "elementosToMatch "+this.data.id+" incorrecta";
                    }
                });

                let promedio = (100 * aciertos) / matchesArry.length;

                if (promedio >= 70) {
                    this.$swal({
                    type: "success",
                    title: "¡EN HORA BUENA!",
                    text: `Tu promedio de aciertos en esta actividad es del ${Math.round(promedio)}%`,
                    showCancelButton: false,
                    confirmButtonColor: "#285c4d",
                    confirmButtonText: "Aceptar"
                    }).then(result => {
                    if (result.value) {
                    }
                    });
                } else {
                    this.$swal({
                    type: "warning",
                    title: "¡PROMEDIO BAJO!",
                    text: `Tu promedio de aciertos en esta actividad es del ${Math.round(promedio)}%`,
                    showCancelButton: false,
                    confirmButtonColor: "#285c4d",
                    confirmButtonText: "Aceptar"
                    }).then(result => {
                    if (result.value) {
                    }
                    });
                }

                console.log(aciertos);
            },
        },
    };
</script>

<style lang="scss">
#preview {
    margin-top: 20px;
    text-align: center;
}
.pre-relacional-activity{
    background-color: #ceebf0;
    border-radius: .5rem;
    padding-top: 10px; 

    .card {
        border-radius: .2rem;
        margin-right: auto;
        margin-left: auto;
    }
    .img-thumbnail{
        border-radius: .3rem;
    }
}
.elementosToMatch {
    width: 100%;
    height: auto;
    cursor: pointer;
    text-align: center;
    min-height: 30px;
    font-size: 16px;
    line-height: 30px;
}
.listaRespuestas {
    height: auto;
    background-color: #ffffff;
    border: 1px solid #aaaaaa;
    border-radius: .2rem;
    cursor: pointer;
    text-align: center;
    font-size: 16px;
    min-height: 35px;
    line-height: 30px;
    align-self: center;
    margin: 5px;
    padding: 10px;
}

.correcta {
    border: 1px solid green !important;
}
.incorrecta {
    border: 1px solid red !important;
}
input .custom-file-input{
  cursor: pointer !important;
}
//TODO: ver los cuadros de relacion 
</style>